// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a-nav-link {
  font-size: 14px;
  height: 60px;
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/acds-about/About.scss"],"names":[],"mappings":"AACA;EACE,eAAA;EACA,YAAA;EACA,aAAA;AAAF","sourcesContent":["\n.a-nav-link {\n  font-size: 14px;\n  height: 60px;\n  padding: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
